import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ClubSubscribe } from '../club-subscribe/club-subscribe';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, ClubSubscribe],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {}